import { render, staticRenderFns } from "./stdx-form.vue?vue&type=template&id=1e21bc8e&scoped=true&"
import script from "./stdx-form.ts?vue&type=script&lang=ts&"
export * from "./stdx-form.ts?vue&type=script&lang=ts&"
import style0 from "./stdx-form.scss?vue&type=style&index=0&id=1e21bc8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e21bc8e",
  null
  
)

export default component.exports